import React, { Component } from 'react';
import ProjectAssociableTpWaveItem from '../../../Domain/ThirdParty/Project/ProjectAssociableTpWaveItem';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';
import FigmaButton from '../../../Elements/FigmaButton';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OverWindow from '../../../Elements/TabList/OverWindow';
import TpWaveService from '../../../Services/TpWaveService';
import TpWaveSearchParams from './TpWaveSearchParams';

class AssociateTpWavePanel extends Component {
  constructor(props) {
    super(props);

    const searchItem = new TpWaveSearchParams();
    searchItem.ProjectId = props.searchItem.ProjectId;
    searchItem.IsAssocationSearch = true;

    this.state = {
      loading: true,
      itemList: [],
      saving: false,
      isOverWindow: true,
      searchItem,
    };

    ProjectAssociableTpWaveItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  componentDidMount() {}

  clickOnSelect(item) {
    const updatedList = this.state.itemList.map((element) => {
      if (element.TpWaveId === item.TpWaveId) {
        return {
          ...element,
          Selected: !element.Selected,
        };
      }
      return element;
    });

    this.setState({
      itemList: updatedList,
    });
  }

  handleOnSubmit() {
    this.setState({ saving: true });

    const selectedTpWaveIds = this.state.itemList.filter((item) => item.Selected).map((item) => item.TpWaveId);
    const temp = {
      Id: this.props.searchItem.ProjectId,
      TpWaveIds: selectedTpWaveIds,
    };

    ErrorMessage.SetNotification(
      'The wave association process started in the background. This might take some time, you will be notified via in-app notification when the process has finished.'
    );
    TpWaveService.AssociateProjectTpWave(temp)
      .then((result) => {
        if (result && result !== 'None.' && result.errorMessage) {
          ErrorMessage.SetErrorMessage(result.errorMessage);
        } else {
          ErrorMessage.SetNotification(
            `The waves have been successfully associated with the project ${this.props.searchItem.ProjectId}.`
          );
        }
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: ATWP70. Wave association failed. Please notify IT!');
      });

    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        altKey: false,
        code: 'Escape',
        ctrlKey: false,
        isComposing: false,
        key: 'Escape',
        location: 0,
        metaKey: false,
        repeat: false,
        shiftKey: false,
        which: 27,
        charCode: 0,
        keyCode: 27,
      })
    );
  }

  renderCancelAndSubmitButtons() {
    return (
      <ButtonFooterContainer>
        <FigmaButton
          className='applySurveyPanelButton'
          label='Submit'
          submit={true}
          iconName={`fa-solid fa-upload${this.state.saving ? ' fa-spin' : ''}`}
          disabled={this.state.saving || !this.state.itemList.find((f) => f.Selected)}
          type={ButtonTypeEnum.ExtraLargeNormal}
          color={ButtonColorsEnum.Primary}
          iconPosition={IconPositionEnum.Left}
          onClick={this.handleOnSubmit.bind(this)}
        />
      </ButtonFooterContainer>
    );
  }

  render() {
    if (this.props.isOverWindow) {
      return (
        <OverWindow
          title={'Associate Third-Party Wave'}
          clickOnCancel={() => {
            if (!this.state.saving) this.props.clickOnCancel(false);
          }}
          closeOnClickOutside={false}
          iconName='fa-solid fa-plus-circle'
          zIndex={1050}
          className='applySurveyPanel top-of-boxFigma'
          verticalScroll={false}
        >
          <div className='container-fluid verticalScrollForSearch height50vh'>
            <TabOfDataTable
              itemList={this.state.itemList}
              type={ProjectAssociableTpWaveItem}
              serviceFunction={TpWaveService.GetTpWaveItemList}
              changeOfItemListFunction={(itemList) => this.setState({ itemList })}
              convertDBItemsFunction={TpWaveService.ConvertToProjectAssociableTpWaveItem}
              showSearchStrip={true}
              singleSearchLinePlaceholder='Search in Wave ID or Name...'
              singleSearchLine={true}
              enableUrlPush={false}
              searchParamsType={TpWaveSearchParams}
              clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
              searchItem={this.state.searchItem}
              isFilterDisabled={true}
              isRefreshDisabled={true}
              forceClearCacheOnSearch={true}
            />
            {this.renderCancelAndSubmitButtons()}
          </div>
        </OverWindow>
      );
    }
  }
}

export default AssociateTpWavePanel;
